import * as React from "react";
import CommonApiPaths from "Application/Common/Constants/CommonApiPaths";
import Const from 'Utils/Consts';
import { NetStatusContextType } from "Models/INetStatus";
import { useEffect, useRef } from "react";

const NetStatusContext = React.createContext<NetStatusContextType | null>({
    ...window.env
})

export const NetStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [netStatus, setNetStatus] = React.useState<"ON" | "OFF" | "MANUAL_OFF">("ON")
    const netStatusRef = useRef(netStatus);
    const intervalMs = 15000
    const timeoutMs = 4000

    useEffect(() => {
        netStatusRef.current = netStatus
    }, [netStatus]);

    useEffect(() => {
        const newNetStatus = localStorage.getItem("NEW_STATUS")
        if (newNetStatus) {
            if (newNetStatus == "ON")
                setNetStatus("ON")
            else if (newNetStatus == "OFF")
                setNetStatus("OFF")
            else if (newNetStatus == "MANUAL_OFF")
                setNetStatus("MANUAL_OFF")
        }
    }, []);

    useEffect(() => {
        let aborted = false;

        const check = async () => {
            try {
                const controller = new AbortController();
                const t = setTimeout(() => controller.abort(), timeoutMs);

                const res = await fetch(`${Const.env.REACT_APP_API_GATEWAY_URL}${CommonApiPaths.HealthCheck}`, {
                    method: "GET",
                    cache: "no-store",
                    headers: { "Accept": "text/plain" },
                    signal: controller.signal,
                });

                clearTimeout(t);
                if (!aborted) {
                    setNetStatus("ON");
                    localStorage.setItem("NEW_STATUS", "ON")
                }
            } catch {
                if (!aborted) {
                    setNetStatus("OFF");
                    localStorage.setItem("NEW_STATUS", "OFF")
                }
            }
        };

        const interval = setInterval(() => {
            if (netStatusRef.current != "MANUAL_OFF")
                check()
        }, intervalMs)

        return () => {
            clearInterval(interval)
        };
    }, []);

    const setManualStatus = (value: "ON" | "OFF" | "MANUAL_OFF") => {
        setNetStatus(value)
        localStorage.setItem("NEW_STATUS", value)
    }

    return (
        <NetStatusContext.Provider value={{ netStatus, setNetStatus: setManualStatus }}>
            {children}
        </NetStatusContext.Provider>
    )
}

export const useNetStatus = (): NetStatusContextType => {
    const context = React.useContext(NetStatusContext)
    if (!context) {
        throw new Error("Has Internet Not Found...")
    }
    return context
}